
import React from 'react';
import AdminUsersUnified from '@/pages/admin/AdminUsersUnified';

const UsersManagement: React.FC = () => {
  return <AdminUsersUnified />;
};

export default UsersManagement;
